import { areUtterancesEqual } from "../utils";
import { Utterance } from "@knowt/syncing/types/common";
import { useState } from "react";
import { useDebounce } from "react-use";

type Props = {
    utterances: Utterance;
    currentTime: number;
};
export const useActiveTranscriptSegment = ({ utterances, currentTime }: Props) => {
    const [activeSegment, setActiveSegment] = useState<Utterance[number]>();

    useDebounce(
        () => {
            const newActiveSegment = utterances.find(
                utterance => utterance.start <= currentTime && currentTime < utterance.end
            );

            setActiveSegment(oldActiveSegment => {
                return oldActiveSegment && newActiveSegment && areUtterancesEqual(oldActiveSegment, newActiveSegment)
                    ? oldActiveSegment
                    : newActiveSegment;
            });
        },
        10,
        [currentTime, utterances]
    );

    return activeSegment;
};
